<template>
  <div class="pts-done">
    <div class="pts-done__icon">
      <i class="material-icons">check_circle</i>
    </div>
    <p class="pts-done__body">
      <template v-if="final">Thank you for your feedback</template>
      <template v-else>Feedback for <strong>{{ sectionTitle }}</strong> complete - please press "Continue"</template>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    final: { type: Boolean, default: false },
    sectionTitle: { type: String, default: '' },
  },
}
</script>
